import React, { useRef, useState } from "react";
import { Button, Alert, TextField } from "@mui/material";
import { useAuth } from "../../../contexts/AuthContext";
import { authService } from "../../../api/services/auth";
import { api } from "../../../api/client";
import { endpoints } from "../../../api/endpoints";
import useRemote from "../../../hooks/useRemote";

export default function AccountSecurity({ showPassword = false }) {
  const { user, logout, clearAuthentication } = useAuth();
  const sessions = useRemote((signal) => authService.sessions({ signal }));
  const status = useRemote((signal) => authService.status({ signal }));
  const [busy, setBusy] = useState(false);
  const pending = useRef(false);
  const [error, setError] = useState("");
  const rows = Array.isArray(sessions.data) ? sessions.data : sessions.data?.results ?? [];
  const perform = async (action) => {
    if (pending.current) return;
    pending.current = true; setBusy(true); setError("");
    try { await action(); } catch (failure) { setError(failure.message); }
    finally { pending.current = false; setBusy(false); }
  };
  const changePassword = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const fields = new FormData(form);
    if (fields.get("new_password") !== fields.get("confirm")) {
      setError("تکرار رمز عبور یکسان نیست."); return;
    }
    perform(async () => {
      await api.request({ url: endpoints.student.changePassword, method: "POST",
        data: { old_password: fields.get("old_password"), new_password: fields.get("new_password") } });
      form.reset(); clearAuthentication();
    });
  };
  return <section className="rounded-panel border border-rule-subtle bg-surface p-xl space-y-6">
    <h2 className="text-xl font-semibold">امنیت حساب</h2>
    <p>{[user?.first_name, user?.last_name].filter(Boolean).join(" ")} · <bdi>{user?.username}</bdi></p>
    {status.data && <p>ورود دومرحله‌ای: {status.data.enabled ? "فعال" : "غیرفعال"} {status.data.required && " (الزامی)"}</p>}
    {status.error && <Alert severity="error">{status.error.message}</Alert>}
    {showPassword && <form onSubmit={changePassword} className="flex flex-wrap gap-4">
      <TextField name="old_password" type="password" label="رمز فعلی" autoComplete="current-password" required />
      <TextField name="new_password" type="password" label="رمز جدید" autoComplete="new-password" required />
      <TextField name="confirm" type="password" label="تکرار رمز جدید" autoComplete="new-password" required />
      <Button type="submit" disabled={busy}>تغییر رمز و خروج</Button>
    </form>}
    <h3>نشست‌های فعال</h3>
    {sessions.loading && <p role="status">در حال دریافت نشست‌ها…</p>}
    {(error || sessions.error) && <Alert severity="error">{error || sessions.error.message}</Alert>}
    {!sessions.loading && !sessions.error && rows.length === 0 && <p>نشستی برای نمایش وجود ندارد.</p>}
    <div className="overflow-x-auto"><table className="w-full text-right"><thead><tr>
      {["دستگاه", "نشانی", "کشور", "ایجاد", "آخرین فعالیت", "انقضا", "عملیات"].map((title) => <th className="p-3" key={title}>{title}</th>)}
    </tr></thead><tbody>{rows.map((row) => <tr key={row.id ?? row.token_key}>
      <td className="p-3">{row.device || "نامشخص"} {row.current && "(این دستگاه)"}</td>
      <td><bdi>{row.ip_address || "—"}</bdi></td><td>{row.country || "—"}</td>
      {[row.created, row.last_used, row.expiry].map((value, index) => <td key={index}>{value ? new Date(value).toLocaleString("fa-IR") : "—"}</td>)}
      <td><Button disabled={busy || row.id == null} onClick={() => perform(async () => {
        await authService.revokeSession(row.id);
        if (row.current) clearAuthentication(); else sessions.reload();
      })}>لغو نشست</Button></td>
    </tr>)}</tbody></table></div>
    <Button disabled={busy} onClick={() => perform(() => logout(true))} color="error">خروج از همه دستگاه‌ها</Button>
  </section>;
}
